import script from "./App.vue.ts?vue&type=script&lang=ts&setup=true!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue.ts?vue&type=script&lang=ts&setup=true!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue.less?vue&type=style&index=0&id=1c5cfbba&lang=less!=!../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=style&index=0&id=1c5cfbba&lang=less"

const __exports__ = script;

export default __exports__